<field-chiplist-component [field]="field" [isUpdate]="isUpdate" [useSummaryView]="useSummaryView"
    [validTypes]="validTypes"></field-chiplist-component>